// extracted by mini-css-extract-plugin
var _1 = "_projectManagement-module__button-container";
var _2 = "_projectManagement-module__title";
export { _1 as "button-container", _2 as "title" }
